import { BASE_URL } from "./Constants";

export const GET_EXCLUDED_SERVICE = `${BASE_URL}api/external/Common/GetExcludedServices`;
